document.addEventListener("DOMContentLoaded", () => {

    console.log("🔥 AI STYLIST JS FILE LOADED");


    const API_URL =
        "https://grafted-sandstone-feisty.ngrok-free.dev/upload-image";


    const imageInput =
        document.getElementById("stylist-image");


    const analyzeBtn =
        document.getElementById("analyze-btn");


    const preview =
        document.getElementById("preview");


    const loading =
        document.getElementById("loading");


    const analysisDiv =
        document.getElementById("analysis");


    const recommendationsDiv =
        document.getElementById("recommendations");



    if(!imageInput || !analyzeBtn){

        console.error(
            "❌ AI Stylist elements missing"
        );

        return;

    }



    // ================================
    // IMAGE PREVIEW
    // ================================


    imageInput.addEventListener(
        "change",
        ()=>{


            const file =
                imageInput.files[0];


            if(!file)
                return;



            preview.innerHTML = `

                <img

                src="${URL.createObjectURL(file)}"

                style="
                width:250px;
                border-radius:16px;
                margin-top:20px;
                "

                >

            `;


        }
    );



    // ================================
    // BUTTON CLICK
    // ================================


    analyzeBtn.addEventListener(
        "click",
        async ()=>{


            console.log(
                "🔥 FIND MY STYLE CLICKED"
            );



            const file =
                imageInput.files[0];



            if(!file){

                alert(
                    "Please upload outfit image"
                );

                return;

            }



            const formData =
                new FormData();



            formData.append(
                "file",
                file
            );



            loading.style.display =
                "block";


            analysisDiv.innerHTML="";
            recommendationsDiv.innerHTML="";



            try{


                console.log(
                    "📤 Sending image to backend"
                );



                const response =
                    await fetch(

                        API_URL,

                        {

                            method:"POST",

                            body:formData

                        }

                    );


                console.log(
                    "Backend Status:",
                    response.status
                );



                const data =
                    await response.json();



                console.log(
                    "FULL RESPONSE:",
                    data
                );

                loading.style.display =
                    "none";



                // =================================
                // OUTFIT ANALYSIS DISPLAY
                // =================================


                const outfit =
                    data.analysis || {};



                analysisDiv.innerHTML = `

                <div class="analysis-card">


                    <h2>
                        ✨ AI Outfit Analysis
                    </h2>


                    <p>
                        <b>Dress Type:</b>
                        ${
                            outfit.dress_type ||
                            "Unknown"
                        }
                    </p>


                    <p>
                        <b>Primary Colors:</b>
                        ${
                            outfit.primary_colors
                            ?
                            outfit.primary_colors.join(", ")
                            :
                            "Unknown"
                        }
                    </p>


                    <p>
                        <b>Secondary Colors:</b>
                        ${
                            outfit.secondary_colors
                            ?
                            outfit.secondary_colors.join(", ")
                            :
                            "Unknown"
                        }
                    </p>


                    <p>
                        <b>Style:</b>
                        ${
                            outfit.styles
                            ?
                            outfit.styles.join(", ")
                            :
                            "Unknown"
                        }
                    </p>


                    <p>
                        <b>Occasion:</b>
                        ${
                            outfit.occasion ||
                            "Unknown"
                        }
                    </p>


                    <p>
                        <b>Pattern:</b>
                        ${
                            outfit.pattern ||
                            "Unknown"
                        }
                    </p>


                </div>

                `;



                // =================================
                // GET TABS
                // =================================


                const tabs =
                    data.recommendations?.tabs || {};



                console.log(
                    "AVAILABLE TABS:",
                    Object.keys(tabs)
                );



                const tabsContainer =
                    document.createElement(
                        "div"
                    );


                tabsContainer.className =
                    "stylist-tabs";



                const productsContainer =
                    document.createElement(
                        "div"
                    );


                productsContainer.className =
                    "products-container";



                recommendationsDiv.appendChild(
                    tabsContainer
                );


                recommendationsDiv.appendChild(
                    productsContainer
                );



                // =================================
                // PRODUCT RENDER FUNCTION
                // =================================


                function renderProducts(products){


                    productsContainer.innerHTML="";



                    if(
                        !products ||
                        products.length === 0
                    ){

                        productsContainer.innerHTML = `

                        <div class="analysis-card">

                            <h3>
                            No products found
                            </h3>


                            <p>
                            AI could not find matches in this category.
                            </p>


                        </div>

                        `;


                        return;

                    }



                    products.forEach(
                        product=>{


                            const card =
                                document.createElement(
                                    "div"
                                );


                            card.className =
                                "product-card";



                            card.innerHTML = `


                            ${
                                product.image
                                ?

                                `

                                <img

                                src="${product.image}"

                                class="product-image"

                                >

                                `

                                :

                                ""

                            }



                            <div class="product-info">


                                <h3>

                                    ${
                                        product.title ||
                                        "Accessory"
                                    }

                                </h3>



                                <p class="product-price">

                                    ₹
                                    ${
                                        product.price ||
                                        ""
                                    }

                                </p>



                                <p>

                                    ${
                                        product.reason ||
                                        "AI Recommended Match"
                                    }

                                </p>



                                <p>

                                    ⭐ Score:

                                    ${
                                        product.score ||
                                        product.candidate_score ||
                                        0
                                    }

                                </p>



                                <a

                                href="/products/${product.handle}"

                                >

                                View Product

                                </a>



                            </div>



                            `;



                            productsContainer.appendChild(
                                card
                            );


                        }

                    );


                }
                                // =================================
                // CREATE TAB BUTTONS
                // =================================


                Object.keys(tabs).forEach(
                    (tabName, index)=>{


                        const tabButton =
                            document.createElement(
                                "button"
                            );


                        tabButton.className =
                            "stylist-tab";


                        tabButton.innerText =
                            tabName;



                        if(index === 0){

                            tabButton.classList.add(
                                "active"
                            );


                            renderProducts(
                                tabs[tabName]
                            );

                        }



                        tabButton.addEventListener(
                            "click",
                            ()=>{


                                document
                                .querySelectorAll(
                                    ".stylist-tab"
                                )
                                .forEach(
                                    btn=>
                                    btn.classList.remove(
                                        "active"
                                    )
                                );



                                tabButton.classList.add(
                                    "active"
                                );



                                renderProducts(
                                    tabs[tabName]
                                );


                            }
                        );



                        tabsContainer.appendChild(
                            tabButton
                        );


                    }
                );



                console.log(
                    "✅ AI Stylist Finished"
                );



            }

            catch(error){


                console.error(
                    "❌ AI Stylist Error:",
                    error
                );



                loading.style.display =
                    "none";



                recommendationsDiv.innerHTML = `


                <div class="analysis-card">


                    <h3>
                    ❌ Something went wrong
                    </h3>


                    <p>
                    Unable to connect with AI Stylist.
                    </p>


                </div>


                `;


            }



        }

    );



});